<template>
  <kanbanWrap>
    <Row :gutter="16">
      <Col span="6">
        <div class="block" style="height: 340px">
          <h2 class="title">车辆</h2>
          <div class="chartWrap">
            <pie ref="pie"></pie>
          </div>
        </div>
        <div class="block" style="height: 330px">
          <h2 class="title">
            人员
          </h2>
          <div class="chartWrap">
            <licheng ref="licheng"></licheng>
          </div>
        </div>
      </Col>
      <Col span="12">
        <kanbanselect-group></kanbanselect-group>
        <div class="block" style="height: 600px; position: relative">
          <ecmap ref="ecmap"></ecmap>
          <mapMenu @mapData="reMapMenu"></mapMenu>
        </div> </Col
      ><Col span="6">
        <div class="block" style="height: 340px">
          <h2 class="title">
            事件上报统计<startEnd
              @startend="$refs.paigongxiangmu.reach($event)"
            ></startEnd>
          </h2>
          <div class="chartWrap">
            <paigongxiangmu ref="paigongxiangmu"></paigongxiangmu>
          </div>
        </div>
        <div class="block" style="height: 330px">
          <h2 class="title">
            作业里程统计
          </h2>
          <div class="chartWrap">
            <paigongzonglan ref="paigongzonglan"></paigongzonglan>
          </div>
        </div>
      </Col>
    </Row>
    <Row :gutter="16">
      <Col span="6">
        <div class="block" style="height: 330px">
          <h2 class="title">
            人员考勤
          </h2>
          <div class="chartWrap">
            <youhao ref="youhao"></youhao>
          </div>
        </div>
      </Col>
      <Col span="6">
        <div class="block" style="height: 330px">
          <h2 class="title">扫地车辆作业统计</h2>
          <div class="chartWrap">
            <saodiche></saodiche>
          </div>
        </div> </Col
      ><Col span="6">
        <div class="block" style="height: 330px">
          <h2 class="title">清运车辆作业统计</h2>
          <div class="chartWrap">
            <xunchache ref="pie"></xunchache>
          </div>
        </div> </Col
      ><Col span="6">
        <div class="block" style="height: 330px">
          <h2 class="title">
            作业异常报警<startEnd
              @startend="$refs.cheliangbaojing.reach($event)"
            ></startEnd>
          </h2>
          <div class="chartWrap">
            <cheliangbaojing ref="cheliangbaojing"></cheliangbaojing>
          </div>
        </div>
      </Col>
    </Row>
  </kanbanWrap>
</template>
<script>
import startEnd from "./statrEnd.vue";
import kanbanWrap from "../kanbanWrap.vue";
import youhao from "./youhao.vue";
import licheng from "./licheng.vue";
import xunchache from "./xunchache.vue";
import saodiche from "./saodiche.vue";
import pie from "./pie";
import ecmap from "./ecmap.vue";
import paigongzonglan from "./paigongzonglan.vue";
import cheliangbaojing from "./cheliangbaojing.vue";
import paigongxiangmu from "./paigongxiangmu.vue";
import mapMenu from "./mapMenu.vue";
import kanbanselectGroup from "./kanbanselectGroup.vue";
export default {
  components: {
    pie,
    startEnd,
    kanbanWrap,
    youhao,
    licheng,
    xunchache,
    saodiche,
    ecmap,
    paigongzonglan,
    cheliangbaojing,
    paigongxiangmu,
    mapMenu,
    kanbanselectGroup,
  },

  data() {
    return {};
  },
  methods: {
    reMapMenu(v, m) {
      if (m == "收集点") {
        setTimeout(() => {
          this.$refs.ecmap.showLjt(v);
        }, 1500);
      } else if (m == "公厕") {
        setTimeout(() => {
          this.$refs.ecmap.showGongce(v);
        }, 1500);
      }else if (m == "作业人员") {
        setTimeout(() => {
          this.$refs.ecmap.showpersons(v);
        }, 1500);
      } else if (m == "扫地车辆") {
        setTimeout(() => {
          this.$refs.ecmap.showXisao(v);
        }, 1500);
      } else if (m == "作业网格") {
        this.$refs.ecmap.showWangge(v);
      } else if (m == "清运车辆") {
        setTimeout(() => {
          this.$refs.ecmap.showQingyun(v);
        }, 1500);
      } else if (m == "作业线路") {
        setTimeout(() => {
          this.$refs.ecmap.showline(v);
        }, 500);
      }
    },
  },
  mounted() {},
};
</script>

<style lang="">
#big {
  width: 1920px;
  height: 1080px;
  padding: 0 16px;
  transform-origin: 0 0;
}
#big p,
#big div {
  color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/kanban/control/index.vue